/**
 * Complementary products - checkboxes, total price update, product description popup, add to cart
 */
(function () {
  function formatMoney(cents, format) {
    if (!format) format = '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, (cents / 100).toFixed(0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function initComplementaryProducts(container) {
    if (!container) return;

    const mainVariantsEl = container.querySelector('.complementary-products__main-variants');
    const checkboxes = container.querySelectorAll('.cc-test-product');
    const modal = container.querySelector('modal-dialog.complementary-product-modal');
    const modalTitle = modal?.querySelector('.complementary-product-modal__title');
    const modalDesc = modal?.querySelector('.complementary-product-modal__description');
    const modalImage = modal?.querySelector('.complementary-product-modal__image');
    const modalImageWrapper = modal?.querySelector('.complementary-product-modal__image-wrapper');

    if (!mainVariantsEl || !checkboxes.length) return;

    let mainProductData;
    try {
      mainProductData = JSON.parse(mainVariantsEl.textContent);
    } catch (e) {
      return;
    }

    const moneyFormat = mainProductData.moneyFormat || '${{amount}}';
    const variantPrices = mainProductData.variantPrices || {};
    const variantOptions = mainProductData.variantOptions || {};

    function getMainProductForm() {
      return container.closest('.js-product')?.querySelector('.js-product-form-main');
    }

    function getMainProductPrice() {
      const productForm = getMainProductForm();
      const variantInput = productForm?.querySelector('input[name="id"]');
      const variantId = variantInput?.value;
      if (!variantId || !variantPrices[variantId]) return 0;
      return parseInt(variantPrices[variantId], 10);
    }

    function getMainProductQuantity() {
      const productForm = getMainProductForm();
      const qtyEl = productForm?.querySelector('[name="quantity"]');
      return parseInt(qtyEl?.value || '1', 10);
    }

    function getMainProductPriceEl() {
      const productSection = container.closest('.js-product');
      return productSection?.querySelector('.product-info__price .price__default .price__current') ||
        productSection?.querySelector('.product-info__price .price__current');
    }

    function getSelectedOptionsForItem(item) {
      const inputs = item.querySelectorAll('.complementary-products__option-input:checked');
      const opts = [];
      inputs.forEach(function (inp) {
        opts[parseInt(inp.dataset.optionIndex, 10)] = inp.value;
      });
      return opts;
    }

    function findVariantForItem(item) {
      const variantsDataEl = item.querySelector('.complementary-products__variant-data');
      if (!variantsDataEl) return null;
      let variants;
      try {
        variants = JSON.parse(variantsDataEl.textContent);
      } catch (e) {
        return null;
      }
      const selectedOpts = getSelectedOptionsForItem(item);
      for (let i = 0; i < variants.length; i++) {
        const v = variants[i];
        let match = true;
        for (let j = 0; j < selectedOpts.length; j++) {
          const optVal = selectedOpts[j];
          const vOpt = v['option' + (j + 1)];
          if (optVal !== vOpt) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return variants.length > 0 ? variants[0] : null;
    }

    function getVariantIdForItem(item) {
      const variantsDiv = item.querySelector('.complementary-products__variants');
      if (variantsDiv && !variantsDiv.classList.contains('hidden')) {
        const v = findVariantForItem(item);
        return v ? v.id : null;
      }
      const cb = item.querySelector('.cc-test-product');
      return cb && cb.checked ? parseInt(cb.dataset.variantId, 10) : null;
    }

    function getQuantityForItem(item) {
      const qtyInput = item.querySelector('.complementary-products__quantity-input');
      const qty = parseInt(qtyInput?.value || '1', 10);
      return qty > 0 ? qty : 1;
    }

    function getUnitPriceForItem(item) {
      const cb = item.querySelector('.cc-test-product');
      if (!cb || !cb.checked) return 0;

      if (cb.dataset.discountedPrice !== undefined) {
        return parseInt(cb.dataset.discountedPrice, 10) || 0;
      }

      const variantsDiv = item.querySelector('.complementary-products__variants');
      if (variantsDiv && !variantsDiv.classList.contains('hidden')) {
        const v = findVariantForItem(item);
        return v ? parseInt(v.price || '0', 10) : 0;
      }
      return parseInt(cb.dataset.price || '0', 10);
    }

    function getLineTotalForItem(item) {
      return getUnitPriceForItem(item) * getQuantityForItem(item);
    }

    function getDisplayUnitPriceForItem(item) {
      const variantsDiv = item.querySelector('.complementary-products__variants');
      if (variantsDiv && !variantsDiv.classList.contains('hidden')) {
        const v = findVariantForItem(item);
        return v ? parseInt(v.price || '0', 10) : 0;
      }
      const cb = item.querySelector('.cc-test-product');
      return cb ? parseInt(cb.dataset.price || '0', 10) : 0;
    }

    function updatePriceDisplayForItem(item) {
      const cb = item.querySelector('.cc-test-product');
      const priceSpan = item.querySelector('.complementary-products__price');
      if (!cb || !priceSpan) return;

      if (cb.dataset.discountedPrice !== undefined) return;

      const lineTotal = getDisplayUnitPriceForItem(item) * getQuantityForItem(item);
      priceSpan.textContent = '(' + formatMoney(lineTotal, moneyFormat) + ')';
    }

    function getSelectedComplementaryTotal() {
      let total = 0;
      const items = container.querySelectorAll('.complementary-products__item');
      items.forEach(function (item) {
        const cb = item.querySelector('.cc-test-product');
        if (cb && cb.checked) {
          total += getLineTotalForItem(item);
        }
      });
      return total;
    }

    function getSelectedComplementaryItems() {
      const selected = [];
      const items = container.querySelectorAll('.complementary-products__item');
      items.forEach(function (item) {
        const cb = item.querySelector('.cc-test-product');
        if (cb && cb.checked) {
          const vid = getVariantIdForItem(item);
          if (vid) selected.push({ id: vid, quantity: getQuantityForItem(item) });
        }
      });
      return selected;
    }

    function updateTotal() {
      const mainPrice = getMainProductPrice();
      const quantity = getMainProductQuantity();
      const complementaryTotal = getSelectedComplementaryTotal();
      const grandTotal = mainPrice * quantity + complementaryTotal;

      const mainPriceEl = getMainProductPriceEl();
      if (mainPriceEl) {
        mainPriceEl.textContent = formatMoney(grandTotal, moneyFormat);
      }

      document.dispatchEvent(new CustomEvent('complementary-products:total-updated', { detail: { totalFormatted: formatMoney(grandTotal, moneyFormat) } }));
    }

    function openModal(productId, openerBtn) {
      const dataEl = container.querySelector('.complementary-product-data[data-product-id="' + productId + '"]');
      if (!modal || !dataEl || !modalTitle || !modalDesc) return;

      const titleEl = dataEl.querySelector('.complementary-product-data__title');
      const descriptionEl = dataEl.querySelector('.complementary-product-data__description');
      const imageUrl = dataEl.dataset.imageUrl || '';
      const title = titleEl ? titleEl.textContent : '';
      const description = descriptionEl ? descriptionEl.innerHTML : '';

      modalTitle.textContent = title;
      modalDesc.innerHTML = description || '<p>No description available.</p>';

      if (modalImage && modalImageWrapper) {
        if (imageUrl) {
          modalImage.src = imageUrl;
          modalImage.alt = title;
          modalImageWrapper.hidden = false;
        } else {
          modalImage.src = '';
          modalImage.alt = '';
          modalImageWrapper.hidden = true;
        }
      }

      if (typeof modal.open === 'function') {
        modal.open(openerBtn);
      }
    }

    function toggleVariantsForItem(item, show) {
      const variantsDiv = item.querySelector('.complementary-products__variants');
      const cb = item.querySelector('.cc-test-product');

      if (!variantsDiv) return;
      variantsDiv.classList.toggle('hidden', !show);

      if (show) {
        const v = findVariantForItem(item);
        if (cb && v) {
          cb.dataset.variantId = v.id;
          cb.dataset.price = v.price || '0';
        }
      } else if (cb) {
        const variantsDataEl = item.querySelector('.complementary-products__variant-data');
        var firstPrice = cb.dataset.price || '0';
        if (variantsDataEl) {
          try {
            const variants = JSON.parse(variantsDataEl.textContent);
            const first = variants.find(function (v) { return v.available; }) || variants[0];
            if (first) firstPrice = first.price || '0';
          } catch (e) {}
        }
        cb.dataset.price = firstPrice;
      }

      updatePriceDisplayForItem(item);
    }

    // --- Size-based addon filtering (foundry70x70 / foundry80x80 tags) ---

    function normalizeSizeValue(optionValue) {
      return (optionValue || '').toLowerCase().replace(/[^0-9x]/g, '');
    }

    function getCurrentSizeFragment() {
      const productForm = getMainProductForm();
      const variantId = productForm?.querySelector('input[name="id"]')?.value;
      const options = variantOptions[variantId] || [];
      for (let i = 0; i < options.length; i++) {
        const normalized = normalizeSizeValue(options[i]);
        if (normalized === '70x70' || normalized === '80x80') {
          return normalized;
        }
      }
      return '';
    }

    function itemMatchesCurrentSize(item, sizeFragment) {
  const tags = (item.dataset.tags || '')
    .split(',')
    .map(function (t) { return t.trim().toLowerCase(); })
    .filter(Boolean);

  // Only "foundry" + digit counts as a size tag (e.g. "foundry70x70").
  // "Foundry Bench", "Foundry Bench Corner", etc. must NOT match.
  const sizeTags = tags.filter(function (t) { return /^foundry\d/.test(t); });

  if (sizeTags.length === 0) return true; // no size tag = always shown
  if (!sizeFragment) return true;

  return sizeTags.some(function (t) { return t === 'foundry' + sizeFragment; });
}

    function applySizeFilter() {
      const sizeFragment = getCurrentSizeFragment();

      container.querySelectorAll('.complementary-products__item').forEach(function (item) {
        const matches = itemMatchesCurrentSize(item, sizeFragment);
        item.hidden = !matches;

        if (!matches) {
          const cb = item.querySelector('.cc-test-product');
          if (cb && cb.checked) {
            cb.checked = false;
            cb.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }

    // --- end size-based addon filtering ---

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        const item = checkbox.closest('.complementary-products__item');
        if (item && item.dataset.hasVariants === 'true') {
          toggleVariantsForItem(item, checkbox.checked);
        }
        updateTotal();
      });
    });

    container.addEventListener('click', function (e) {
      const nameBtn = e.target.closest('.complementary-products__name');
      if (nameBtn && nameBtn.dataset.productId) {
        e.preventDefault();
        e.stopPropagation();
        openModal(nameBtn.dataset.productId, nameBtn);
      }
    });

    container.addEventListener('input', function (e) {
      const qtyInput = e.target.closest('.complementary-products__quantity-input');
      if (qtyInput) {
        const item = qtyInput.closest('.complementary-products__item');
        if (item) updatePriceDisplayForItem(item);
        updateTotal();
      }
    });

    container.addEventListener('change', function (e) {
      const qtyInput = e.target.closest('.complementary-products__quantity-input');
      if (qtyInput) {
        const item = qtyInput.closest('.complementary-products__item');
        if (item) updatePriceDisplayForItem(item);
        updateTotal();
        return;
      }
      const input = e.target.closest('.complementary-products__option-input');
      if (!input) return;
      const item = input.closest('.complementary-products__item');
      if (!item) return;
      const cb = item.querySelector('.cc-test-product');
      const v = findVariantForItem(item);
      if (cb && v) {
        cb.dataset.variantId = v.id;
        cb.dataset.price = v.price || '0';
      }
      updatePriceDisplayForItem(item);
      updateTotal();
    });

    document.addEventListener('on:variant:change', function (e) {
      if (container.closest('.js-product') && container.closest('.js-product').contains(e.target)) {
        applySizeFilter();
        updateTotal();
      }
    });

    const productForm = getMainProductForm();
    const qtyEl = productForm?.querySelector('[name="quantity"]');
    if (qtyEl) {
      qtyEl.addEventListener('change', updateTotal);
      qtyEl.addEventListener('input', updateTotal);
    }

    container._getSelectedComplementaryItems = getSelectedComplementaryItems;
    container._openDescriptionModal = openModal;

    applySizeFilter();
    updateTotal();
  }

  var addToCartInterceptorSetup = false;

  function setupAddToCartInterceptor() {
    if (addToCartInterceptorSetup) return;
    addToCartInterceptorSetup = true;
    document.addEventListener('submit', function (evt) {
      const form = evt.target;
      if (!form || !form.classList.contains('js-product-form-main')) return;

      const productSection = form.closest('.js-product');
      if (!productSection) return;

      const complementaryContainer = productSection.querySelector('.complementary-products-checkboxes');
      if (!complementaryContainer || !complementaryContainer._getSelectedComplementaryItems) return;

      const complementaryItems = complementaryContainer._getSelectedComplementaryItems();
      if (complementaryItems.length === 0) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      const productForm = form.closest('product-form');
      const submitBtn = productForm?.querySelector('[name="add"]');
      const errorMsg = productForm?.querySelector('.js-form-error');
      const cartDrawer = document.querySelector('cart-drawer');

      let sections = 'cart-icon-bubble';
      if (cartDrawer) {
        const drawerSectionId = cartDrawer.closest('.shopify-section')?.id?.replace('shopify-section-', '');
        if (drawerSectionId) sections += ',' + drawerSectionId;
      }

      const variantId = parseInt(form.querySelector('input[name="id"]')?.value, 10);
      const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);

      if (!variantId) return;

        const items = [
          {
            id: variantId,
            quantity: quantity
          }
        ];

        complementaryItems.forEach(function (complementaryItem) {
          items.push({
            id: complementaryItem.id,
            quantity: complementaryItem.quantity,
            properties: {
              "_bundle_addon": "yes",
              "_bundle_parent_variant": String(variantId)
            }
          });
        });
      const payload = {
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      };

      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('is-loading');
      }
      if (errorMsg) {
        errorMsg.hidden = true;
        errorMsg.innerHTML = '';
      }

      fetch(typeof theme !== 'undefined' && theme.routes ? theme.routes.cartAdd : '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (_a) {
          var ok = _a.ok, data = _a.data;
          if (!ok && data.description) {
            if (errorMsg) {
              errorMsg.textContent = typeof data.description === 'string' ? data.description : data.message || '';
              errorMsg.hidden = false;
            }
            return;
          }
          if (data.errors && typeof data.errors === 'object') {
            var errText = Object.entries(data.errors).map(function (e) { return e[1].join(', '); }).join(' ');
            if (errorMsg) {
              errorMsg.textContent = errText;
              errorMsg.hidden = false;
            }
            return;
          }
          if (typeof theme !== 'undefined' && theme.settings && theme.settings.afterAtc === 'page') {
            window.location.href = (typeof theme !== 'undefined' && theme.routes ? theme.routes.cart : '/cart');
            return;
          }
          if (data.sections) {
            const cartIconBubble = document.getElementById('cart-icon-bubble');
            if (cartIconBubble && data.sections['cart-icon-bubble']) {
              cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
            }
            if (cartDrawer && cartDrawer.renderContents) {
              const shouldOpen = typeof theme !== 'undefined' && theme.settings && theme.settings.afterAtc === 'drawer';
              setTimeout(function () {
                cartDrawer.renderContents(data, shouldOpen);
              }, 700);
            }
          }
        })
        .catch(function (err) {
          console.error(err);
          if (errorMsg) {
            errorMsg.textContent = 'Unable to add items to cart. Please try again.';
            errorMsg.hidden = false;
          }
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.classList.add('is-success');
            submitBtn.removeAttribute('aria-disabled');
            setTimeout(function () {
              submitBtn.classList.remove('is-loading');
              submitBtn.classList.remove('is-success');
            }, 1400);
          }
        });
    }, true);
  }

  function setupDescriptionPopupDelegation() {
    document.addEventListener('click', function (e) {
      const nameBtn = e.target.closest('.complementary-products__name');
      if (!nameBtn || !nameBtn.dataset.productId) return;

      const container = nameBtn.closest('.complementary-products-checkboxes');
      if (!container || !container._openDescriptionModal) return;

      e.preventDefault();
      e.stopPropagation();
      container._openDescriptionModal(nameBtn.dataset.productId, nameBtn);
    });
  }

  const processedContainers = new WeakSet();

  function init() {
    document.querySelectorAll('.complementary-products-checkboxes').forEach(function (container) {
      if (!processedContainers.has(container)) {
        processedContainers.add(container);
        initComplementaryProducts(container);
      }
    });
  }

  function observeRecommendations() {
    const recommendations = document.querySelectorAll('product-recommendations[data-url*="intent=complementary"]');
    recommendations.forEach(function (el) {
      if (el._complementaryObserved) return;
      el._complementaryObserved = true;
      const observer = new MutationObserver(function () {
        init();
      });
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupDescriptionPopupDelegation();
      setupAddToCartInterceptor();
      init();
      observeRecommendations();
      setTimeout(init, 500);
      setTimeout(init, 1500);
    });
  } else {
    setupDescriptionPopupDelegation();
    setupAddToCartInterceptor();
    init();
    observeRecommendations();
    setTimeout(init, 500);
    setTimeout(init, 1500);
  }

  document.addEventListener('shopify:section:load', init);
})();


/* UNIVERSAL WISHLIST / QUOTE ACCESSORY STORAGE */

function initUniversalAccessoryStorage(container) {
  if (!container || container.dataset.accessoryStorageReady === 'true') {
    return;
  }

  container.dataset.accessoryStorageReady = 'true';

  const productSection =
    container.closest('.single_product') ||
    document.querySelector('.single_product');

  /*
   * Get current product handle.
   *
   * Best source is a data attribute if available.
   * Otherwise derive it from current URL.
   */
  const getProductHandle = () => {
    const explicitHandle =
      productSection?.dataset?.productHandle ||
      container.dataset.productHandle;

    if (explicitHandle) {
      return explicitHandle;
    }

    const match =
      window.location.pathname.match(/\/products\/([^/?#]+)/);

    return match ? match[1] : '';
  };

  const productHandle = getProductHandle();

  if (!productHandle) {
    console.warn(
      'Accessory storage: product handle could not be determined.'
    );

    return;
  }

  const storageKey =
    'selected_accessories_' + productHandle;


  const normalizeImage = (url) => {
    if (!url) return '';

    const value = String(url);

    return value.startsWith('//')
      ? 'https:' + value
      : value;
  };


  const getCheckbox = (item) => {
    return item.querySelector(
      '.cc-test-product, .complementary-products__checkbox'
    );
  };


  const getQuantity = (item) => {
    const input =
      item.querySelector(
        '.complementary-products__quantity-input'
      );

    const quantity =
      parseInt(
        input ? input.value : '1',
        10
      );

    return quantity > 0
      ? quantity
      : 1;
  };


  const getSelectedOptions = (item) => {
    const options = {};

    item
      .querySelectorAll(
        '.complementary-products__option'
      )
      .forEach((optionWrapper) => {
        const label =
          optionWrapper
            .querySelector('label')
            ?.textContent
            ?.replace(':', '')
            ?.trim();

        const selectedInput =
          optionWrapper.querySelector(
            '.complementary-products__option-input:checked'
          );

        if (label && selectedInput) {
          options[label] =
            selectedInput.value;
        }
      });

    return options;
  };


  const getAccessoryData = (item) => {
    const checkbox =
      getCheckbox(item);

    if (!checkbox) {
      return null;
    }

    const variantId =
      String(
        checkbox.dataset.variantId || ''
      ).replace(
        'gid://shopify/ProductVariant/',
        ''
      );

    if (!variantId) {
      return null;
    }

    const productId =
      String(
        checkbox.dataset.productId ||
        item.dataset.productId ||
        ''
      );

    const productData =
      item.querySelector(
        '.complementary-product-data'
      );

    const title =
      productData
        ?.querySelector(
          '.complementary-product-data__title'
        )
        ?.textContent
        ?.trim()

      ||

      item
        .querySelector(
          '.complementary-products__name'
        )
        ?.textContent
        ?.trim()

      ||

      '';

    const imageElement =
      item.querySelector(
        '.complementary-products__thumbnail img'
      );

    const image =
      normalizeImage(
        productData?.dataset.imageUrl ||
        imageElement?.currentSrc ||
        imageElement?.src ||
        ''
      );

    const originalPriceCents =
      parseInt(
        checkbox.dataset.price || '0',
        10
      ) || 0;

    const discountedPriceCents =
      checkbox.dataset.discountedPrice !== undefined &&
      checkbox.dataset.discountedPrice !== ''
        ? parseInt(
            checkbox.dataset.discountedPrice,
            10
          ) || 0
        : originalPriceCents;

    return {
      variantId: variantId,
      productId: productId,
      title: title,
      image: image,

      price:
        originalPriceCents / 100,

      originalPrice:
        originalPriceCents / 100,

      discountedPrice:
        discountedPriceCents / 100,

      quantity:
        getQuantity(item),

      options:
        getSelectedOptions(item)
    };
  };


  const saveAccessories = () => {
    const selectedAccessories = [];

    container
      .querySelectorAll(
        '.complementary-products__item'
      )
      .forEach((item) => {
        const checkbox =
          getCheckbox(item);

        if (
          !checkbox ||
          !checkbox.checked
        ) {
          return;
        }

        const accessory =
          getAccessoryData(item);

        if (accessory) {
          selectedAccessories.push(
            accessory
          );
        }
      });


    /*
     * Avoid duplicate variants.
     */
    const uniqueAccessories =
      Array.from(
        new Map(
          selectedAccessories.map(
            (accessory) => [
              String(accessory.variantId),
              accessory
            ]
          )
        ).values()
      );


    localStorage.setItem(
      storageKey,
      JSON.stringify(
        uniqueAccessories
      )
    );


    console.log(
      'Universal accessories saved:',
      storageKey,
      uniqueAccessories
    );
  };


  const restoreAccessories = () => {
    let savedAccessories = [];

    try {
      savedAccessories =
        JSON.parse(
          localStorage.getItem(
            storageKey
          ) || '[]'
        );
    } catch (error) {
      savedAccessories = [];
    }

    if (
      !Array.isArray(
        savedAccessories
      )
    ) {
      return;
    }


    container
      .querySelectorAll(
        '.complementary-products__item'
      )
      .forEach((item) => {
        const checkbox =
          getCheckbox(item);

        if (!checkbox) {
          return;
        }

        const variantId =
          String(
            checkbox.dataset.variantId || ''
          ).replace(
            'gid://shopify/ProductVariant/',
            ''
          );

        const productId =
          String(
            checkbox.dataset.productId ||
            item.dataset.productId ||
            ''
          );

        const savedAccessory =
          savedAccessories.find(
            (accessory) => {
              const sameVariant =
                variantId &&
                String(
                  accessory.variantId
                ) === variantId;

              const sameProduct =
                productId &&
                String(
                  accessory.productId
                ) === productId;

              return (
                sameVariant ||
                sameProduct
              );
            }
          );

        if (!savedAccessory) {
          return;
        }

        checkbox.checked = true;

        const quantityInput =
          item.querySelector(
            '.complementary-products__quantity-input'
          );

        if (
          quantityInput &&
          savedAccessory.quantity
        ) {
          quantityInput.value =
            savedAccessory.quantity;
        }
      });
  };


  /*
   * Delegated listener on THIS complementary block.
   */
  container.addEventListener(
    'change',
    (event) => {
      const target =
        event.target;

      if (!(target instanceof Element)) {
        return;
      }

      if (
        target.matches(
          '.cc-test-product, .complementary-products__checkbox'
        ) ||
        target.matches(
          '.complementary-products__quantity-input'
        )
      ) {
        setTimeout(
          saveAccessories,
          0
        );

        return;
      }

      if (
        target.matches(
          '.complementary-products__option-input'
        )
      ) {
        /*
         * Wait for complementary-products.js
         * to update variant ID / price first.
         */
        setTimeout(
          saveAccessories,
          100
        );
      }
    }
  );


  restoreAccessories();
}


/*
 * Initialize every complementary products block.
 */
function initAllUniversalAccessoryStorage() {
  document
    .querySelectorAll(
      '.complementary-products-checkboxes'
    )
    .forEach((container) => {
      initUniversalAccessoryStorage(
        container
      );
    });
}


initAllUniversalAccessoryStorage();


/*
 * Recommendations can load after page load,
 * so initialize newly injected blocks too.
 */
const universalAccessoryObserver =
  new MutationObserver(() => {
    initAllUniversalAccessoryStorage();
  });


universalAccessoryObserver.observe(
  document.documentElement,
  {
    childList: true,
    subtree: true
  }
);